import type { Team } from '@/types/tournament.model';

export type TVTeamFaceSlot = {
  imageUrl: string | null;
  initials: string;
};

function initialsFromFullName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (
      parts[0].charAt(0).toUpperCase() +
      parts[parts.length - 1].charAt(0).toUpperCase()
    );
  }
  const one = parts[0] ?? '';
  const s = (one.charAt(0) + (one.charAt(1) || '')).toUpperCase();
  return s || '?';
}

export function getTvTeamFaceSlots(
  team: Team | undefined,
): [TVTeamFaceSlot, TVTeamFaceSlot] {
  const players = team?.players ?? [];
  const slot = (idx: 0 | 1): TVTeamFaceSlot => {
    const p = players[idx];
    if (!p?.name?.trim()) {
      return { imageUrl: null, initials: idx === 0 ? 'P1' : 'P2' };
    }
    return {
      imageUrl: p.profileImageUrl?.trim() || null,
      initials: initialsFromFullName(p.name),
    };
  };
  return [slot(0), slot(1)];
}
